var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"lg":"2"}},[_c('v-skeleton-loader',_vm._b({attrs:{"type":"avatar"}},'v-skeleton-loader',_vm.attrs,false))],1),_c('v-col',{attrs:{"lg":"10"}},[_c('v-skeleton-loader',_vm._b({attrs:{"type":"list-item-three-line, actions"}},'v-skeleton-loader',_vm.attrs,false))],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }